export const MOUNTAIN_ISLAND_AREA_CODES = new Set<string>([
  '0210',
  '3129',
  '3213',
  '3313',
  '3314',
  '3411',
  '3412',
  '3518',
  '3621',
  '3812',
  '3813',
  '4017',
  '4018',
  '4225',
  '4226',
  '4227',
  '4322',
  '4326',
  '4327',
  '4328',
  '4329',
  '4330',
  '4331',
  '4332',
  '4333',
  '4401',
  '4402',
  '4403',
  '4404',
  '4405',
  '4406',
  '4508',
  '4511',
  '4512',
  '4513',
  '4611',
  '4612',
  '4613',
  '4614',
  '4615',
  '4616',
  '9001',
  '9002',
  '9003',
  '9004',
  '9005',
  '9006',
  '9101',
  '9102',
  '9103',
  '9104'
]);

export const MOUNTAIN_ISLAND_AREA_KEYWORDS = [
  '\u5927\u540c\u9109',
  '\u5357\u6fb3\u9109',
  '\u70cf\u4f86\u5340',
  '\u91d1\u57ce\u93ae',
  '\u91d1\u5be7\u93ae',
  '\u91d1\u5be7\u9109',
  '\u91d1\u6c99\u93ae',
  '\u91d1\u6e56\u93ae',
  '\u70c8\u5dbc\u9109',
  '\u70cf\u5775\u9109',
  '\u70cf\u4e18\u9109',
  '\u5357\u7aff\u9109',
  '\u5317\u7aff\u9109',
  '\u8392\u5149\u9109',
  '\u6771\u5f15\u9109',
  '\u5fa9\u8208\u5340',
  '\u5c16\u77f3\u9109',
  '\u4e94\u5cf0\u9109',
  '\u6cf0\u5b89\u9109',
  '\u548c\u5e73\u5340',
  '\u4ec1\u611b\u9109',
  '\u4fe1\u7fa9\u9109',
  '\u963f\u91cc\u5c71',
  '\u5927\u57d4\u9109',
  '\u6843\u6e90\u5340',
  '\u90a3\u746a\u590f',
  '\u8302\u6797\u5340',
  '\u4f86\u7fa9\u9109',
  '\u4e09\u5730\u9580',
  '\u9727\u53f0\u9109',
  '\u746a\u5bb6\u9109',
  '\u7261\u4e39\u9109',
  '\u6625\u65e5\u9109',
  '\u7345\u5b50\u9109',
  '\u6cf0\u6b66\u9109',
  '\u7409\u7403\u9109',
  '\u767d\u6c99\u9109',
  '\u99ac\u516c\u5e02',
  '\u671b\u5b89\u9109',
  '\u4e03\u7f8e\u9109',
  '\u6e56\u897f\u9109',
  '\u897f\u5dbc\u9109',
  '\u6771\u6c99',
  '\u5357\u6c99',
  '\u8c50\u6ff1\u9109',
  '\u79c0\u6797\u9109',
  '\u842c\u69ae\u9109',
  '\u5353\u6eaa\u9109',
  '\u5ef6\u5e73\u9109',
  '\u6d77\u7aef\u9109',
  '\u91d1\u5cf0\u9109',
  '\u9054\u4ec1\u9109',
  '\u7da0\u5cf6\u9109',
  '\u862d\u5dbc\u9109'
];

export function normalizeMountainIslandAreaCode(value: string): string {
  const digits = (value || '').replace(/\D/g, '');
  if (!digits) return '';
  return digits.length > 4 ? digits.slice(-4) : digits.padStart(4, '0');
}

export function isMountainIslandArea(value: string): boolean {
  const code = normalizeMountainIslandAreaCode(value);
  return !!code && MOUNTAIN_ISLAND_AREA_CODES.has(code);
}

export function isMountainIslandLocationText(value: string): boolean {
  const normalized = normalizeMountainIslandLocationText(value);
  return !!normalized && MOUNTAIN_ISLAND_AREA_KEYWORDS.some(keyword =>
    normalized.includes(normalizeMountainIslandLocationText(keyword))
  );
}

export function isMountainIslandClinic(clinic: { IsMountain?: boolean }): boolean {
  if (!clinic) return false;
  return clinic.IsMountain === true;
}

function normalizeMountainIslandLocationText(value: string): string {
  return (value || '').replace(/\u53f0/g, '\u81fa').replace(/\s/g, '').trim();
}
